import { ToastContainer } from "react-toastify";

import About from "./components/about/About";
import Header from "./components/header/Header";
import LowerAbout from "./components/lowerAbout/LowerAbout";
import RoadMap from "./components/roadMap/RoadMap";
import Tokonomics from "./components/tokonomics/Tokonomics";
import OurTeam from "./components/ourTeam/OurTeam";
import Solar from "./components/solar/Solar";
import Footer from "./components/footer/Footer";
import SolarUseCase from "./components/solarUseCase/SolarUseCase";
import PreSale from "./components/preSale/PreSale";
import { Route } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Partnership from "./components/partnership/Partnership";
import Sneakpeak from "./components/sneakpeak/Sneakpeak";
import MediaMentions from "./components/mediaMentions/MediaMentions";
function App() {
  return (
    <div className="App">
      <Route exact path="/">
        <Header />
        <About />
        <LowerAbout />
        <Tokonomics />
        <RoadMap />
        <OurTeam />
        <SolarUseCase />
        <Partnership />
        <MediaMentions />
        <Sneakpeak />
        <Solar />
        <Footer />
      </Route>
      <Route exact path="/preSale">
        <Header />
        <PreSale />
        <Footer />
      </Route>
      <ToastContainer />
    </div>
  );
}

export default App;
